<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Visitas</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="$can('store', 'visits')" class="col-lg-6 col-5 text-right">
          <router-link
            :to="{ name: 'VisitCreate', query: { schedule: false } }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Nueva
          </router-link>
          <router-link
            :to="{ name: 'VisitCreate', query: { schedule: true } }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Programar Visita
          </router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <visits-table />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import VisitsTable from './List/VisitsTable';

export default {
  name: 'VisitList',
  components: {
    VisitsTable,
    RouteBreadCrumb,
  },
};
</script>
